import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { Button } from './ui/button';
import { StaggeredMenu } from './StaggeredMenu';
import { RadiusMark } from './RadiusMark';
import { MENU } from '../data/menu';

// Global site header. Cinematic aesthetic on every route: StaggeredMenu on
// the left drives all primary navigation, the RadiusMark + wordmark is the
// centred brand anchor (links to /), and a "Let's Chat" CTA lives on the
// right. No inline nav links — the StaggeredMenu owns route discovery.
export const Header = () => {
  // Route id -> path so the StaggeredMenu items link to real pages.
  const menuIdToPath = {
    solutions: '/solutions',
    work: '/portfolio',
    company: '/about',
    blog: '/blog',
    resources: '/resources',
    contact: '/contact',
  };

  return (
    <header
      className="cinematic-scope fixed top-0 left-0 right-0 z-50 bg-background/80 backdrop-blur-xl border-b border-border/60"
      data-testid="site-header"
    >
      <StaggeredMenu
        items={MENU.map((m) => ({ id: m.id, label: m.label }))}
        onItemClick={(id) => {
          const path = menuIdToPath[id];
          if (path) window.location.href = path;
        }}
      />

      <div className="relative max-w-7xl mx-auto px-6 h-20 flex items-center justify-between">
        {/* Reserve space for the StaggeredMenu toggle sitting at top:24 / left:24 */}
        <div className="w-32" aria-hidden />

        {/* Centred wordmark */}
        <Link
          to="/"
          className="absolute left-1/2 -translate-x-1/2 flex items-center gap-2 md:gap-3 group"
          data-testid="site-header-brand"
        >
          <RadiusMark size={28} className="md:hidden transition-transform group-hover:scale-110" />
          <RadiusMark size={32} className="hidden md:block transition-transform group-hover:scale-110" />
          <span className="font-display text-base md:text-xl tracking-[0.2em] md:tracking-[0.3em] uppercase text-foreground">
            Radius
          </span>
        </Link>

        {/* Right — Let's Chat CTA (hidden on mobile; use the menu instead) */}
        <Link
          to="/contact"
          data-testid="site-header-cta"
          className="hidden md:inline-flex"
        >
          <Button variant="hero" size="lg">
            Connect
            <ArrowRight className="ml-2 w-4 h-4" />
          </Button>
        </Link>
      </div>
    </header>
  );
};

export default Header;
